import { Box, Tooltip, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { color } from '@/colors';
import { I18N_KEYS } from '@/language/keys';

/** Light pill label + explanatory tooltip (matches Properties drawer BYOK treatment). */
export const ByokBadge = () => {
  const { t } = useTranslation();
  const byokLabel = t(I18N_KEYS.RECIPE_MAIN.FLOW.DRAWER.MODEL_PROPERTIES.BYOK_LABEL);
  const byokTooltip = t(I18N_KEYS.RECIPE_MAIN.FLOW.DRAWER.MODEL_PROPERTIES.BYOK_TOOLTIP);
  return (
    <Tooltip title={byokTooltip} placement="top">
      <Box
        component="span"
        aria-label={byokTooltip}
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          alignSelf: 'flex-start',
          width: 'fit-content',
          maxWidth: '100%',
          px: 0.75,
          py: 0.25,
          borderRadius: 1,
          bgcolor: color.Black08,
          color: color.Black92,
          flexShrink: 0,
          cursor: 'default',
        }}
      >
        <Typography component="span" variant="label-xs-rg" sx={{ color: color.Black92 }}>
          {byokLabel}
        </Typography>
      </Box>
    </Tooltip>
  );
};
